"use client";

import styles from "./global-error.module.scss";

/**
 * Global error boundary. Catches unhandled errors in the root layout.
 * Must define its own <html> and <body>; root layout is not rendered.
 */
export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <html lang="en">
      <body className={styles.body}>
        <div className={styles.inner}>
          <h1 className={styles.code}>500</h1>
          <h2 className={styles.heading}>Internal server error</h2>
          <p className={styles.message}>
            Something went wrong on our end. Please try again or come back later.
          </p>
          <div className={styles.actions}>
            <button type="button" onClick={reset} className={styles.button}>
              Try again
            </button>
            <a href="/" className={styles.link}>
              Go home
            </a>
          </div>
        </div>
      </body>
    </html>
  );
}
